export default __webpack_public_path__ + "static/mynft-49f460b2c97f434eff2617cfda368aa0.png";